import { render, staticRenderFns } from "./TipoMandatoEdit.vue?vue&type=template&id=3564057e&scoped=true&"
import script from "./TipoMandatoEdit.vue?vue&type=script&lang=js&"
export * from "./TipoMandatoEdit.vue?vue&type=script&lang=js&"
import style0 from "./TipoMandatoEdit.vue?vue&type=style&index=0&id=3564057e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564057e",
  null
  
)

export default component.exports